/**
 * Given a file url, return the extension name i.e. "png"
 */
export const getFileExtensionName = (url: string) => {
    // Get the file extension name from filename ie "https://example.com/file.png" => "png"
    let extension = url.match(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gim);
    let extensionName = null;

    if (Array.isArray(extension)) {
        extensionName = extension[0].replace('.', '').toLowerCase();
    }

    return extensionName;
};

/**
 * Given a url, return the file name i.e. "https://example.com/file.png" => "file"
 */
export const getFileName = (url: string) => decodeURIComponent(url.split('/').pop() || '');
